import React from "react";
import { Skeleton } from "@mui/material";

export default function () {
    return <React.Fragment>
        <Skeleton animation="wave" height={25} />
        <Skeleton animation="wave" height={50} />
        <Skeleton animation="wave" height={50} />
        <Skeleton animation="wave" height={50} />
        <Skeleton animation="wave" height={50} />
        <Skeleton animation="wave" height={50} />
    </React.Fragment>
}